import styled, { css } from 'styled-components';
import { Button, ClickAnchor } from 'components/core';

const AccountRemoveLink = styled(ClickAnchor)`
  color: var(--color-grey1);
  font-size: 15px;
  font-weight: 600;

  &:hover {
    color: var(--color-stromboli);
  }
`;

const ConnectionRemoveButton = styled(Button)`
  min-width: unset;
  min-height: unset;
  padding: 6px 12px;
  white-space: nowrap;

  &.MuiButton-outlined {
    border-color: var(--color-whiteSmoke2);
    color: var(--color-grey1);
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;

    &:hover {
      border-color: var(--color-grey1);
      box-shadow: none;
      color: var(--color-black19);
    }

    &:focus {
      border-width: 1px;
      border-color: var(--color-whiteSmoke2);
    }

    &:focus-visible {
      border-color: var(--color-bg-button-main);
      border-width: 2px;
    }
  }
`;

const modalButtonPadding = css`
  min-width: unset;
  min-height: unset;
  padding-left: 24px;
  padding-right: 24px;
`;

const ModalCancelButton = styled(Button)`
  ${modalButtonPadding}
`;

const ModalConfirmButton = styled(Button)`
  ${modalButtonPadding}

  &.MuiButton-contained {
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    text-shadow: none;
  }
`;

export const Styled = {
  AccountRemoveLink,
  ConnectionRemoveButton,
  ModalCancelButton,
  ModalConfirmButton,
};
